/**
 * A base and generic class to handle chat messages regardless of context
 */
import BaseClass from '../core/BaseClass';
import WidgetTypes from '../core/enums/WidgetTypes';
import TempCache from '../core/enums/TempCache';
import { PreChatMessageAnimation } from '../core/enums/Enum';
import getHeightOfElement from '../core/hooks/getHeightOfElement';
import MessageStatus from '../core/hooks/MessageStatus';
import MessageVisibility from '../core/hooks/MessageVisibility';
import PreChatMessageAnimations from '../core/hooks/PreChatMessageAnimations';
import MessageView from '../core/MessageView';

export default class VideoGreetBaseMessageHandler extends BaseClass {
    // inheriting with BaseClass
    constructor(options) {
        super(options);
        this.options = Object.assign(options, {
            objectType: WidgetTypes.MessageHandler,
            ADAHandler: options.ADAHandler,
            context: options.context,
            videoGreetModel: options.videoGreetModel
        });

        this.messages = [];
    }

    push(model) {
        // push is not array push, its taking model as argument and doing several tasks.
        const me = this;
        const msg = new MessageView({
            context: this.options.context,
            wrap: this.options.wrap,
            targetElementSelector: this.options.targetElementSelector,
            renderOninit: this.options.renderOninit,
            model,
            template: model.template,
            index: this.messages.length,
            status: MessageStatus.Unread,
            visibility: MessageVisibility.Visible
        });
        const last = this.getLastMessage();

        if (this.messages.length > 0) {
            msg.isFirstMessage = false;
            this.messages[this.messages.length - 1].isLastMessage = false;
        }
        this.messages.push(msg);
        msg.view.removeClass('apexchat_prechat_show_message_fade_out');
        // getting lastMsg's duration of being on screen.
        const lastMsgModel = me.options.videoGreetModel.videoGreetMessages.filter(
            (prechatMsgArray) => {
                if (last) {
                    return prechatMsgArray.id === last.view.model.id;
                }
            }
        );
        const duration = lastMsgModel[0] || { duration: 1 }; // Default:1//getting lastMsg's duration of being on screen.
        const animationConfig = {};
        // we are defining some configs for animations as we have similar animations Stacking & Mobile-Stacking
        // both are similar just few differences, like; faddingout timing, effect, close button difference, etc.
        if (this.options.preChatMessageAnimation == PreChatMessageAnimation.Stacking) {
            // defining config for Stacking
            animationConfig.StartFaddingOutAfter = 1000; // msg fadeout time
            animationConfig.HideMessageAfter = animationConfig.StartFaddingOutAfter; // hide the msg (which will resize iframe too)
            animationConfig.IFrameResizeAfterFaddingOut = animationConfig.StartFaddingOutAfter + 20; // adding 20ms in timeout for iframe resizing
            animationConfig.closeButtonSupported = 'No'; // close button is not supported in Stacking
        } else if (this.options.preChatMessageAnimation == PreChatMessageAnimation.MobileStacking) {
            // defining config for MobileStacking
            animationConfig.HideMessageAfter = duration.duration * 1000; // msg fadeout time
            animationConfig.StartFaddingOutAfter = 0.4 * 1000; // hide the msg (which will resize iframe too)
            animationConfig.closeButtonHeight = 30; // close button Height
            animationConfig.IFrameResizeAfterFaddingOut = 1000 + 20; // 20ms more // hide the msg (which will resize iframe too)
            animationConfig.closeButtonSupported = 'Yes'; // close button is supported in Mobile-Stacking
        }
        const heightCalculation = new this.heightCalculation({
            me: this,
            currentMsgView: msg.view,
            lastMsg: last,
            animationConfig,
            model
        });
        if (msg.isFirstMessage) {
            // FIRST Message
            // encapsulated the whole logic to make the clean implementation..
            heightCalculation.fixFirstElement();
            // Adding Animation to First/current msg.
            msg.animate(PreChatMessageAnimations.First, 0);
        } else {
            // NORMAL Messaging

            if (model.isFromHistory && me.isPageRefreshed()) {
                // encapsulated the whole logic to make the clean implementation..
                heightCalculation.fixFirstElement(duration);
            } else {
                // encapsulated the whole logic to make the clean implementation..
                heightCalculation.fixUpComingElement(duration);
                // Adding Animation to previous msgs and fading them after user's defined time.
                // duration of being on screen.
                if (last.animate) {
                    last.animate(PreChatMessageAnimations.Previous, 0);
                    last.animate(
                        PreChatMessageAnimations.FadeOut,
                        animationConfig.StartFaddingOutAfter || 0
                    );
                }
            }
            // Adding Animation to current msg.
            msg.animate(PreChatMessageAnimations.Upcoming, 0);
        }
    }

    heightCalculation(options) {
        const self = this;
        self.elementObj = options;
        const { animationConfig } = options;
        const { me } = options;
        const extraHeight = 5;
        const msgPopupElementFirst = () => {
            // we need this timeout as DOM takes time to render, without timeout.
            // ApexChat.getStyle giving wrong values without timeout.
            setTimeout(() => {
                const { currentMsgView } = self.elementObj;
                const ele = me.$(`#${currentMsgView.identifier}`, currentMsgView.context);
                if (ele[0]) {
                    // jquery selector element[0] returns default DOM html ele obj.
                    // we need calculations here for placing msg popup with animation one over the other.
                    me.postMessage({
                        event: 'prechat-auto-resizing',
                        data: {
                            currentMsgHeight: getHeightOfElement(ele[0]),
                            isSingleMsg: true
                        }
                    });
                    const calcCurrentMsgHeight =
                        TempCache.PRECHAT_Rounded_Message_Popup_Current_Height -
                        getHeightOfElement(ele[0]) +
                        extraHeight;
                    ele.css(
                        'top',
                        `${calcCurrentMsgHeight + (animationConfig.closeButtonHeight || 0)}px`
                    );
                }
            }, 50);
        };
        function msgPopupElementUpcoming(duration) {
            const { currentMsgView } = self.elementObj;
            const last = self.elementObj.lastMsg;
            // Its obvious that UpComing msg scenario, FirstMsg or Prev has already been executed.
            // removing classes of first and upcoming msg from previous popup
            if (last.view.removeClass) {
                last.view.removeClass('apexchat_prechat_show_message_fade_out');
                last.view.removeClass(PreChatMessageAnimations.First);
                last.view.removeClass(PreChatMessageAnimations.Upcoming);
            }
            // duration timeout to keep them in vision according to user defined time.
            setTimeout(() => {
                me.$(`#${last.view.identifier}`, last.view.context).hide();
            }, animationConfig.HideMessageAfter);
            const elementlast = me.$(`#${last.view.identifier}`, last.view.context);
            const elementmsg = me.$(`#${currentMsgView.identifier}`, currentMsgView.context);
            // we need this timeout as DOM takes time to render, without timeout.
            // ApexChat.getStyle giving wrong values without timeout.
            setTimeout(() => {
                if (elementlast[0]) {
                    // we need calculations here for placing msg popup with animation one over the other.
                    // Resizing IFrame incase of Stack Msgs and making IFrame Wide enough to show the Stacked Msgs.
                    me.postMessage({
                        event: 'prechat-auto-resizing',
                        data: {
                            currentMsgHeight: getHeightOfElement(elementmsg[0]),
                            prevMsgHeight: getHeightOfElement(elementlast[0]),
                            dontAnimateClosebutton: true
                        }
                    });
                    const calcLastMsgHeight =
                        TempCache.PRECHAT_Rounded_Message_Popup_Last_Height -
                        getHeightOfElement(elementmsg[0]) -
                        getHeightOfElement(elementlast[0]); //
                    const calcCurrentMsgHeight =
                        TempCache.PRECHAT_Rounded_Message_Popup_Current_Height -
                        getHeightOfElement(elementmsg[0]) -
                        20; //
                    elementlast.animate({ top: calcLastMsgHeight }, 300);
                    elementmsg.css(
                        'top',
                        calcCurrentMsgHeight + (animationConfig.closeButtonHeight || 0)
                    );
                }
            }, 50);
            // After fadding out of msg we need to decrease the IFrame size again.
            iFrameResizeOnFadeOut(elementmsg);
        }
        const lastMsgOnPageRefresh = function () {
            const { currentMsgView } = self.elementObj;
            const elementmsg = me.$(`#${currentMsgView.identifier}`, currentMsgView.context);
            const elementlast = me.$(`#${last.view.identifier}`, last.view.context);
            // we need this timeout as DOM takes time to render, without timeout.
            // ApexChat.getStyle giving wrong values without timeout.
            setTimeout(() => {
                // Resizing IFrame incase of Stack Msgs and making IFrame Wide enough to show the Stacked Msgs.
                me.postMessage({
                    event: 'prechat-auto-resizing',
                    data: {
                        currentMsgHeight: getHeightOfElement(elementmsg[0]),
                        prevMsgHeight: getHeightOfElement(elementlast[0])
                    }
                });
                if (elementmsg[0]) {
                    // we need calculations here for placing msg popup with animation one over the other.
                    const calcCurrentHeight =
                        TempCache.PRECHAT_Rounded_Message_Popup_Current_Height -
                        getHeightOfElement(elementmsg[0]);
                    elementmsg.css('top', calcCurrentHeight, 'height');
                }
            }, 50);
            // After fadding out of msg we need to decrease the IFrame size again.
            // _iFrameResize(elementmsg[0]);
        };
        let iFrameResizeOnFadeOut = function (ele) {
            let { IFrameResizeAfterFaddingOut } = animationConfig;
            if (me.isPageRefreshed() && !me.noLastMessageOnRefresh) {
                me.noLastMessageOnRefresh = true;
                IFrameResizeAfterFaddingOut = 1;
            }
            setTimeout(() => {
                me.postMessage({
                    event: 'prechat-auto-resizing',
                    data: {
                        currentMsgHeight: getHeightOfElement(ele[0]),
                        isSingleMsg: true,
                        closeButtonSupported: animationConfig.closeButtonSupported
                    }
                });
                ele.animate({ top: 15 + (animationConfig.closeButtonHeight || 0) }, 1);
            }, IFrameResizeAfterFaddingOut); // for Iframe resizing (animating msg and iframe was causing a glitch).
        };
        return {
            fixFirstElement: msgPopupElementFirst,
            fixUpComingElement: msgPopupElementUpcoming,
            fixLastMsgOnPageRefresh: lastMsgOnPageRefresh
        };
    }
}
